module.exports = __webpack_public_path__ + "static/media/blom-pysanky-64.a9c97b9c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blom-pysanky/blom-pysanky-64.jpg
// module id = 3755
// module chunks = 13